import { useCallback } from 'react';
import { useTrackingContext } from '@zapier/toolbox-tracking';
import {
  dispatchSignupUserInteractionEvent,
  oldSignupTypeToAvroSignupType,
} from '../../avro';
import { GoogleSSOButton } from '../global/GoogleSSOButton';
import { SignupType } from '../../types';
import { addParamsToUrl } from '@zapier/url-utils';

type Props = {
  next?: string | undefined;
  selectedApis?: string | string[];
  useCaseSlug?: string | undefined;
  shouldShowGoogleSSO: boolean;
  invitation?: string;
  from?: string;
};

export function SocialItems({
  next,
  selectedApis,
  shouldShowGoogleSSO,
  invitation,
  from,
}: Props) {
  const params: Record<string, string> = {};

  const nextUrl = next ? addParamsToUrl(next, { from }, true) : undefined;

  if (invitation) {
    params.invitation = invitation;
  }

  if (selectedApis) {
    params.selected_apis = selectedApis as string;
  }

  const { trackSignupIntent } = useTrackingContext();

  const onTrackSignupIntent = useCallback(
    (type: SignupType) => {
      trackSignupIntent(type as any, {
        selectedApis,
      });

      dispatchSignupUserInteractionEvent({
        signupFunnel: 'signup_intent',
        signupType: oldSignupTypeToAvroSignupType(type),
        selectedApis,
      });
    },
    [selectedApis, trackSignupIntent]
  );

  // You may see this and think, this should be a grid, so it's easier to maintain. And you'd be right. The thing is though,
  // If we don't wrap all of these in a div, a weird bug causes the SSO buttons to not render correctly. If it's in a grid
  // and we wrap it in a div, it works fine but the spacing is wrong. This is a hack to get around that.
  return (
    <div>
      {shouldShowGoogleSSO && (
        <div className="google-sso-button-container">
          <GoogleSSOButton
            next={nextUrl}
            onTrackSignupIntent={onTrackSignupIntent}
            params={params}
          >
            Sign up with Google
          </GoogleSSOButton>
        </div>
      )}
    </div>
  );
}
